export enum TwoFactorAuthenticationType {
  DISABLED = 0,
  GOOGLEAUTHENTICATION = 1,
  MAILAUTHENTICATION = 2,
  // SMSAUTHENTICATION = 3,
  // QRCODEAUTHENTICATION = 4,
}
